import { Request } from "@xt/xtbase";
const { XtAxios4 } = Request;
import { getOrigin } from "utils/method";

const URL = getOrigin("financial") + "/api/v4/";

//获取资产列表，只返回有值
export function get_balanceBalances(config?) {
  return XtAxios4.get(URL + `balance/balances`, config);
}
